import script from "./TransferReceipt.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransferReceipt.vue?vue&type=script&setup=true&lang=ts"

import "./TransferReceipt.vue?vue&type=style&index=0&id=47304654&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47304654"]])

export default __exports__